import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import UserSlice from "../ReduxStore/UserSlice";

const loansReducer = (state = { activeLoans: [] }, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_LOANS':
      return { ...state, activeLoans: action.payload };
    default:
      return state;
  }
};

// Persist configuration
const persistConfig = {
  key: "root",       // Root key for persist storage
  storage,           // Local storage as the storage option
};

// Persisted reducer using the persistConfig
const persistedReducer = persistReducer(persistConfig, UserSlice);
export const store = configureStore({
  reducer: {
    user: persistedReducer,  // Use persisted reducer under the "user" slice
    loans: loansReducer,     
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({ 
      serializableCheck: false
    }),
  devTools: false
});

export const persistor = persistStore(store);  // Initialize persistor to manage persistence
